import { useDispatch } from 'react-redux'
import { useCallback } from 'react'

export function useThunkActions<T extends (...args: any[]) => any>(thunk: T) {
  const dispatch = useDispatch()

  return useCallback(
    (...args: Parameters<T>) => {
      return dispatch(thunk(...args))
    },
    [dispatch, thunk]
  )
}
